import {
  Component,
  ComponentFactoryResolver,
  Input,
  OnInit,
} from '@angular/core';
import { ModalController, PopoverController } from '@ionic/angular';


import { SearchpopoverComponent } from './searchpopover/searchpopover.component';
import { FloorplanSearchpopoverComponent } from './floorplan-searchpopover/floorplan-searchpopover.component';
import {
  FloorplanSearchService,
  FloorplanSearchState,
} from './floorplan-search.service';
import { Router } from '@angular/router';
import { PlacesStore } from '../../stores/places.store';

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss'],
})
export class SearchComponent implements OnInit {

  floorplanState: FloorplanSearchState;
  searchPopover: HTMLIonModalElement;
  // @Input() disableSearch = true
  constructor(
    private modalController: ModalController,
    private floorplanSearchService: FloorplanSearchService,
    private router: Router,
    public placesStore: PlacesStore
  ) {}

  ngOnInit() {

  }
  ionViewDidEnter() {}
  openSearch(event) {
    if (this.router.url.includes('favorite-floor-plans')) {
      this.openFloorplanSearch(event);
    } else {
      this.openBookingSearch(event);
    }
  }

  async openFloorplanSearch(event) {
    this.searchPopover = await this.modalController.create({
      component: FloorplanSearchpopoverComponent,
      initialBreakpoint: 0.95,
      breakpoints: [0, 0.95],
      canDismiss : async (data, role) => role != 'gesture',
      componentProps: {
        initialFloorplanSearchRequest:
          this.floorplanSearchService.floorplanSearchState
            .floorplanSearchRequest ?? null,
      },
    });

    await this.searchPopover.present().then();

  }

  async openBookingSearch(event: Event) {

    this.searchPopover = await this.modalController.create({
      component: SearchpopoverComponent,
      initialBreakpoint: 0.95,
      breakpoints: [0, 0.95],
      canDismiss : async (data, role) => role != 'gesture',
      componentProps: {
        modalTitle:
          this.router.url.includes('places') || this.router.url.includes('floor-plan')
            ? 'searchRequestFilterResourcesTitle'
            : 'searchRequestFilterFavoriteTitle',
        initalSearchRequest:
          this.placesStore.searchRequest(),
        },

      });
      
    await this.searchPopover.present().then();

  }
}
